import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerMessageService {
  private messageSubject = new BehaviorSubject<string>('');
  readonly message$: Observable<string> = this.messageSubject.asObservable();

  set(text: string) {
    this.messageSubject.next(text);
  }
}
